import {
  Users,
  Heart,
  Music,
  BookOpen,
  Baby,
  Globe,
  Coffee,
} from 'lucide-react'

export interface Ministry {
  id: string
  title: string
  shortDescription: string
  fullDescription: string
  image: string
  icon: any
  meetingTime?: string
  location?: string
  contact?: string
  features: string[]
  gallery: string[]
}

export const ministriesData: Ministry[] = [
  {
    id: 'childrens-ministry',
    title: "Children's Ministry",
    shortDescription:
      'Kingdom Kids is a place where children can learn about Jesus in a fun, safe, and age-appropriate environment. We have classes for all ages during Sunday services.',
    fullDescription:
      "Kingdom Kids is our vibrant children's ministry designed to help kids birth through fifth grade discover God's love in an exciting, age-appropriate way. Our dedicated team creates a safe, fun environment where children can learn biblical truths, make friends, and develop a genuine relationship with Jesus. Each week, kids engage in interactive lessons, worship, games, and activities that make learning about God memorable and meaningful.",
    image:
      'https://images.unsplash.com/photo-1472162072942-cd5147eb3902?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Baby,
    meetingTime: 'Sundays during service @ 10:00 AM',
    location: 'The Household Church - Kids Wing',
    contact: 'kids@householdchurch.org',
    features: [
      'Age-appropriate Bible lessons',
      'Interactive worship and music',
      'Safe, secure check-in system',
      'Trained and background-checked volunteers',
      'Fun games and activities',
      'Character development focus',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1472162072942-cd5147eb3902?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1560785477-d43d2b34e0df?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'youth-ministry',
    title: 'Youth Ministry',
    shortDescription:
      'Our youth ministry is dedicated to raising up the next generation of leaders. We meet weekly for worship, teaching, and small groups designed for middle and high school students.',
    fullDescription:
      'Our Youth Ministry is a dynamic community for middle and high school students to encounter God, build authentic friendships, and discover their purpose. Through engaging worship, relevant teaching, and meaningful small groups, we create a space where teens can ask hard questions, grow in their faith, and learn to live out their beliefs in everyday life. We believe in empowering young people to be world-changers right now, not just someday.',
    image:
      'https://images.unsplash.com/photo-1529070538774-1843cb3265df?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Users,
    meetingTime: 'Wednesdays @ 7:00 PM',
    location: 'The Household Church - Youth Center',
    contact: 'youth@householdchurch.org',
    features: [
      'Weekly youth services',
      'Small group discipleship',
      'Annual mission trips',
      'Leadership development',
      'Social events and outings',
      'Mentorship programs',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1529070538774-1843cb3265df?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'womens-ministry',
    title: "Women's Ministry",
    shortDescription:
      'Connecting women of all ages to grow in faith and friendship. We host bible studies, retreats, and social events throughout the year.',
    fullDescription:
      "Our Women's Ministry exists to help women of all ages and stages of life connect with God and each other. Through Bible studies, prayer groups, retreats, and fellowship events, we create opportunities for women to grow spiritually, build meaningful relationships, and discover their God-given purpose. Whether you're a new believer or have walked with Christ for years, you'll find a welcoming community of sisters who will encourage and support you on your journey.",
    image:
      'https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Heart,
    meetingTime: 'Various times - See schedule',
    location: 'The Household Church',
    contact: 'women@householdchurch.org',
    features: [
      'Weekly Bible studies',
      'Monthly fellowship gatherings',
      "Annual women's retreat",
      'Prayer groups',
      'Mentorship opportunities',
      'Service projects',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'mens-ministry',
    title: "Men's Ministry",
    shortDescription:
      'Equipping men to be spiritual leaders in their homes, workplaces, and community through discipleship, fellowship, and service.',
    fullDescription:
      "Our Men's Ministry is committed to helping men become the spiritual leaders God has called them to be. Through regular gatherings, Bible studies, and accountability groups, we challenge men to grow in their faith, strengthen their character, and lead with integrity in every area of life. We believe that when men are grounded in God's Word and connected in authentic community, they become powerful forces for good in their families, workplaces, and communities.",
    image:
      'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Users,
    meetingTime: 'Saturdays @ 8:00 AM',
    location: 'The Household Church',
    contact: 'men@householdchurch.org',
    features: [
      "Men's breakfast gatherings",
      'Accountability groups',
      'Leadership training',
      'Service projects',
      "Annual men's retreat",
      'Fatherhood resources',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'worship-arts',
    title: 'Worship Arts',
    shortDescription:
      "A community of creatives using music, production, and media to create an atmosphere of worship and lead people into God's presence.",
    fullDescription:
      "Our Worship Arts ministry brings together musicians, vocalists, tech crew, and creative artists who use their gifts to glorify God and lead our congregation into His presence. We believe worship is more than just music—it's a lifestyle of honoring God in everything we do. Whether you play an instrument, sing, run sound/lights, create graphics, or have other creative gifts, there's a place for you to serve and grow in this ministry.",
    image:
      'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Music,
    meetingTime: 'Rehearsals: Thursdays @ 7:00 PM',
    location: 'The Household Church - Main Sanctuary',
    contact: 'worship@householdchurch.org',
    features: [
      'Vocal and instrumental teams',
      'Technical production crew',
      'Creative media design',
      'Regular training and development',
      'Special worship nights',
      'Recording opportunities',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'outreach-missions',
    title: 'Outreach & Missions',
    shortDescription:
      'Taking the love of Christ beyond the four walls of the church. We support local and global missions to meet physical and spiritual needs.',
    fullDescription:
      "Our Outreach & Missions ministry is passionate about sharing God's love both locally and globally. We believe the church exists not just for itself, but to be a blessing to the world. Through community service projects, mission trips, and partnerships with local and international organizations, we work to meet practical needs while sharing the hope of the gospel. Whether serving in our own neighborhood or traveling across the globe, we're committed to making a tangible difference in Jesus' name.",
    image:
      'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Globe,
    meetingTime: 'Monthly meetings - 3rd Sunday',
    location: 'Various locations',
    contact: 'missions@householdchurch.org',
    features: [
      'Local community service',
      'International mission trips',
      'Food and clothing drives',
      'Partnership with local nonprofits',
      'Disaster relief efforts',
      'Evangelism training',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'deep-dive',
    title: 'Deep Dive',
    shortDescription:
      "Deep Dive into God's Word every Sunday morning. These sessions foster discussion, learning, and spiritual maturity before our main worship service.",
    fullDescription:
      "Deep Dive is our dedicated Bible Study experience designed to help you dig deeper into Scripture in a focused, intimate setting. Every Sunday morning before our main service, we gather to study God's Word together, ask questions, share insights, and grow alongside others who are hungry for God's truth. Whether you're new to the Bible or have been studying it for years, Deep Dive is the place to build a strong foundation in the Word.",
    image:
      'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: BookOpen,
    meetingTime: 'Sundays @ 9:00 AM',
    location: 'The Household Church',
    contact: 'deepdive@householdchurch.org',
    features: [
      'Multiple study groups',
      'Various times and locations',
      'Topical and book studies',
      'Discussion-based format',
      'All ages welcome',
      'Online options available',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'hospitality',
    title: 'Hospitality',
    shortDescription:
      'The first face of the church. Our ushers, greeters, and coffee team ensure everyone feels welcome from the moment they arrive.',
    fullDescription:
      "Our Hospitality team is dedicated to creating a warm, welcoming environment for everyone who walks through our doors. From the parking lot to the sanctuary, our volunteers work together to make sure every guest feels valued and cared for. We believe that hospitality is more than just being friendly—it's about showing people the love of Christ through genuine care and attention. If you have a heart for people and want to help create a welcoming atmosphere, this ministry is for you.",
    image:
      'https://images.unsplash.com/photo-1561047029-3000c68339ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: Coffee,
    meetingTime: 'Sundays - Various shifts',
    location: 'The Household Church',
    contact: 'hospitality@householdchurch.org',
    features: [
      'Greeting team',
      'Ushering ministry',
      'Coffee and refreshments',
      'Parking assistance',
      'Guest services',
      'First-time visitor care',
    ],
    gallery: [
      'https://images.unsplash.com/photo-1561047029-3000c68339ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
]
